import { configureStore } from '@reduxjs/toolkit';
import carReducer from './slices/carSlice';
import driverReducer from './slices/driverSlice';
import authReducer from './slices/authSlice';
import tripReducer from './slices/tripSlice';
import reportsReducer from './slices/reportsSlice';
import carAvailabilityReducer from './slices/carAvailability';
import flashDealsReducer from './slices/flashDealsSlice';
import  cashTransactionsReducer from './slices/cashTransactionsSlice';
import cashTrnReportReducer from './slices/cashTrnReportSlice';
import tripNotificationReducer from './slices/tripNotification';
import leadConversionReportReducer from './slices/leadConversionReportSlice';

export const store = configureStore({
  reducer: {
    cars: carReducer,
    drivers: driverReducer,
    auth: authReducer,
    trips: tripReducer,
    reports: reportsReducer,
    carAvailability: carAvailabilityReducer,
    flashDeals: flashDealsReducer,
    cashTransactions: cashTransactionsReducer,
    cashTrnReport: cashTrnReportReducer,
    tripNotifications: tripNotificationReducer,
    leadConversionReport: leadConversionReportReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
